import React from 'react';
import PropTypes from 'prop-types';

import bootstrapSheet from './BootstrapGoogleSheet';
import 'font-awesome/css/font-awesome.min.css';

class AdminForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createInProgress: false,
            fileName: null,
            template: 'generic'
        };
    }

    onFileNameInputChanged = (event) => {
        const fileName = event.target.value.trim() || null;

        this.setState({fileName});
    }

    onTemplateInputChanged = (event) => {
        const template = event.target.value;

        this.setState({template});
    }

    isCreateDisabled = () => !this.state.fileName || this.state.createInProgress

    onSubmit = async (event) => {
        event.preventDefault();

        if (this.isCreateDisabled()) {
            return;
        }

        this.setState({createInProgress: true});
        const result = await bootstrapSheet({
            accessToken: this.props.accessToken,
            fileName: this.state.fileName,
            template: this.state.template
        });

        window.location.href = result.url;
    }

    render() {
        const createInProgress = this.state.createInProgress;

        return (
            <form onSubmit={this.onSubmit}>
                <p>{'Create new Supplier apprecation file'}</p>
                <label>
                    {'Title'}
                    <input
                        onChange={this.onFileNameInputChanged}
                        style={{display: 'block'}}
                    />
                </label>

                <label>
                    {'Template'}
                    <select
                        onChange={this.onTemplateInputChanged}
                        style={{display: 'block'}}
                        value={this.state.template}
                    >
                        <option
                            value="generic"
                        >
                            {'Generic Event'}
                        </option>
                        <option
                            value="golf"
                        >
                            {'Supplier Appreciation Golf Outing'}
                        </option>
                        <option
                            value="auction"
                        >
                            {'Supplier Appreciation Charity Auction'}
                        </option>
                        <option
                            value="eyc"
                        >
                            {'Exercising Your Character'}
                        </option>
                    </select>
                </label>
                <div className="action-bar">
                    <button
                        disabled={this.isCreateDisabled()}
                        type="submit"
                    >
                        {'Create'}
                        {createInProgress && <span className="fa fa-spinner fa-spin" />}
                    </button>
                </div>
            </form>
        );
    }
}

AdminForm.propTypes = {
    accessToken: PropTypes.string
};

export default AdminForm;



// WEBPACK FOOTER //
// ./src/admin/AdminForm.js